/**
 * Normalize API attendance record (legacy `present` or new `status`).
 */

export function attendanceRecordStatusFromApi(a) {
  if (!a) return 'absent';
  if (a.status && ['present', 'absent', 'excused'].includes(a.status)) return a.status;
  return a.present ? 'present' : 'absent';
}

/** CSS class suffix for roster attendance % (color bands). */
export function attendancePercentToneClass(pct) {
  const n = Number(pct) || 0;
  if (n >= 85) return 'excellent';
  if (n >= 70) return 'good';
  if (n >= 50) return 'fair';
  if (n >= 30) return 'weak';
  return 'poor';
}
